export default {
  title: 'Operator Lookup reports',
  tableHeaderActionTooltip: 'Create new Operator Lookup report',
  dialog: {
    title: {
      generateReport: 'Generate Operator Lookup report',
      deleteReport: 'Delete Operator Lookup report',
      cancelReport: 'Cancel Operator Lookup report',
      regenerateReport: 'Regenerate Operator Lookup report',
      retryReport: 'Retry Operator Lookup report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate Operator Lookup report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter Operator Lookup report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    statuses: {
      label: 'Statuses',
      placeholder: 'Select statuses'
    },
    operationIds: {
      label: 'Operation Ids',
      placeholder: 'Select operation Ids'
    },
    msisdns: {
      label: 'Phone number(s)',
      placeholder: 'Phone number(s)'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    statuses: {
      label: 'Status(es)'
    },
    operationIds: {
      label: 'Operation Id(s)'
    },
    msisdns: {
      label: 'Phone number(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
